import React, { useEffect, useRef } from 'react';
import { getGlobalState, useGlobalState } from '../../store';
import Achart from './Achart';

let tvScriptLoadingPromise;

export default function Lschart() {
  const onLoadScriptRef = useRef();
  const [lskline] = useGlobalState('lskline')


  useEffect(
    () => {
      onLoadScriptRef.current = createWidget;

      if (!tvScriptLoadingPromise) {
        tvScriptLoadingPromise = new Promise((resolve) => {
          const script = document.createElement('script');
          script.id = 'tradingview-widget-loading-script';
          script.src = 'https://s3.tradingview.com/tv.js';
          script.type = 'text/javascript';
          script.onload = resolve;

          document.head.appendChild(script);
        });
      }

      tvScriptLoadingPromise.then(() => onLoadScriptRef.current && onLoadScriptRef.current());

      return () => onLoadScriptRef.current = null;

      function createWidget() {
        if (document.getElementById('tradingview_09adc') && 'TradingView' in window) {
          new window.TradingView.widget({
            autosize: true,
            symbol: `${lskline ==="USDT" ? "BINANCE:USDCUSDT":`BINANCE:${lskline}USDT`}`,
            interval: "15",
            timezone: "Etc/UTC",
            theme: "dark",
            style: "1",
            locale: "in",
            toolbar_bg: "#f1f3f6",
            enable_publishing: false,
            allow_symbol_change: true,
            container_id: "tradingview_09adc"
          });
        }
      }
    },
  );

  return (
    <div className='tradingview-widget-container'>
      <div id='tradingview_09adc' className=" border-[1px] rounded-lg border-[#353949] p-2 bg-[#1c1c24] h-[500px]  md:h-[630px]  2xl:h-[800px]" />
        
      <div className="tradingview-widget-copyright">
      </div>
    </div>
  );
}
